var render = function render(){var _vm=this,_c=_vm._self._c;return _c('design-2021-apprentice-data-table',{attrs:{"items":_vm.groups,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(actions)",fn:function(data){return [_c('b-form-checkbox',{attrs:{"checked":!!data.item.digistudies_access,"switch":""},on:{"change":function($event){return _vm.updateAccess(data.item, $event)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }